/* ------------------------------------------------------------------------------
 *
 *  # Student Resumen Diario Components
 *
 *  Filtros y gestión del resumen diario de estudiantes
 *
 * ---------------------------------------------------------------------------- */

// Variables de estado
let resumenCallbacks = null;

// Callbacks
export function setResumenCallbacks(dotNetRef) {
	resumenCallbacks = dotNetRef;
}

// Filtros
export function applyResumenFilters() {
	const ambienteFilter = document.getElementById('ambienteFilterResumen')?.value || '';
	const asistenciaFilter = document.getElementById('asistenciaFilterResumen')?.value || '';
	const animoFilter = document.getElementById('animoFilterResumen')?.value || '';
	
	if (resumenCallbacks) {
		resumenCallbacks.invokeMethodAsync('ApplyFilters', ambienteFilter, asistenciaFilter, animoFilter);
	}
}

export function clearResumenFilters() {
	const ambienteFilter = document.getElementById('ambienteFilterResumen');
	const asistenciaFilter = document.getElementById('asistenciaFilterResumen');
	const animoFilter = document.getElementById('animoFilterResumen');
	
	if (ambienteFilter) ambienteFilter.value = '';
	if (asistenciaFilter) asistenciaFilter.value = '';
	if (animoFilter) animoFilter.value = '';
	
	if (resumenCallbacks) {
		resumenCallbacks.invokeMethodAsync('ClearFilters');
	}
}

// Helper para poblar ambientes dinámicamente
export function populateAmbientes(ambientes) {
	const ambienteFilter = document.getElementById('ambienteFilterResumen');
	if (!ambienteFilter) return;
	
	// Limpiar opciones existentes excepto "Todos"
	ambienteFilter.innerHTML = '<option value="">Todos los ambientes</option>';
	
	// Agregar ambientes dinámicamente
	ambientes.forEach(ambiente => {
		const option = document.createElement('option');
		option.value = ambiente.id;
		option.textContent = ambiente.nombre;
		ambienteFilter.appendChild(option);
	});
}
